import { authApi } from '@/features/auth/api/auth.api';
import type { AuthResponse, MeResponse } from '@/types';
import type { AuthIntent } from '../constants';
import { resolvePostAuthRoute } from './resolvePostAuthRoute';

interface HandlePostAuthOptions {
  intent?: AuthIntent;
  from?: string;
  setMe: (payload: MeResponse) => void;
}

/** Prefer an explicit post-auth destination over the traveler default `/`. */
function pickMeaningfulRoute(...candidates: Array<string | null | undefined>): string | null {
  for (const route of candidates) {
    if (route && route !== '/') return route;
  }
  return null;
}

export async function handlePostAuth(
  authData: AuthResponse & { isNewUser?: boolean },
  { intent, from, setMe }: HandlePostAuthOptions
): Promise<string> {
  const me = await authApi.getMe({ intent, from });

  const route =
    pickMeaningfulRoute(authData.postAuthRoute, me.postAuthRoute) ??
    resolvePostAuthRoute(me.user, me.permissions, !!authData.isNewUser, from, intent);

  setMe({ ...me, postAuthRoute: route });
  return route;
}

export function pickPostLoginRoute(
  me: MeResponse,
  authData?: Pick<AuthResponse, 'postAuthRoute'>
): string {
  return pickMeaningfulRoute(authData?.postAuthRoute, me.postAuthRoute) ?? '/';
}
